module.exports = function() {
  return new Worker(__webpack_public_path__ + "c8ab4453b072be8abb75.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 1445
// module chunks = 0